import React from "react";
const ONE_HUNDRED_PERCENT = 100;
export const Progress = ({ value, title, maxValue, type = "light", }) => {
    const valuePercent = value / maxValue * ONE_HUNDRED_PERCENT;
    const progressValue = Math.min(Math.max(valuePercent, 0), ONE_HUNDRED_PERCENT);
    const isCompleted = progressValue === ONE_HUNDRED_PERCENT;
    const progressStyle = isCompleted ? {} : { width: `${progressValue}%` };
    const completedClass = isCompleted ? "completed" : "";
    return (React.createElement("div", { className: `progress-linear ${completedClass} ${type}`, role: "progressbar", "aria-valuenow": progressValue, "aria-valuemin": 0, "aria-labelledby": "progress-title", "aria-valuemax": ONE_HUNDRED_PERCENT },
        React.createElement("div", { className: "progress-linear--title", id: "progress-title" }, title),
        React.createElement("div", { className: `progress-linear--completion-container ${completedClass}` },
            React.createElement("div", { className: `progress-linear--completion-certificate ${completedClass}` },
                React.createElement("span", { className: "glyphicon-pro glyphicon-pro-verify-check" }))),
        React.createElement("div", { className: `progress-linear--background ${completedClass}` },
            React.createElement("div", { className: `progress-linear--bar ${completedClass}`, style: progressStyle }))));
};
